import React from 'react';
import clsx from 'clsx';
import { Typography } from '@/components/common';
import { SignReviewFieldStatus } from '@/interfaces';

interface Props {
	label: string;
	value: string | null;
	status?: SignReviewFieldStatus;
}

export const ReviewFieldRow: React.FC<Props> = ({
	label,
	value,
	status = 'not_validated',
}) => {
	const isMismatch = status === 'mismatch';
	const hasValue = value !== null && value !== '';

	return (
		<div className="flex flex-col gap-1">
			<Typography type="regular-12" className="text-gray-35 text-left">
				{label.replace(/:\s*$/, '')}:
			</Typography>
			<Typography
				type="regular-12"
				className={clsx('text-left break-words', {
					'!text-amber-600': isMismatch,
					'!text-gray-35': !hasValue,
				})}
			>
				{isMismatch && <span className="sr-only">Mismatch: </span>}
				{hasValue ? value : '—'}
			</Typography>
			{isMismatch && (
				<Typography type="regular-10" className="!text-amber-600 text-left">
					It does not match the customer&apos;s data.
				</Typography>
			)}
		</div>
	);
};
